module.exports = __webpack_public_path__ + "static/media/Mjollnir.02e23390.png";